import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import apiCumbres from "../axios/axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const SeguimientAbonosContrato = () => {
    const [isLoading, setIsLoading] = useState(false)

    const tkn = useSelector((state) => state.tknAuth)

    //obtener el folio desde el token y mostrar los abonos y mostrar las graficas tipo safibc

    const obtenerPagos = () => {


        const obtener = async () => {

            try {
                setIsLoading(true)
                //obtener folio
                const buscar = await apiCumbres.get(`/seguimiento-abonos?cpi=${tkn.contratoPrestamoId}&tp=I`)

                setIsLoading(false)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener préstamos para autorizar, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        obtener()


    }

    useEffect(() => {
        obtenerPagos()
    }, [])

    return (
        <motion.div layout className="container mb-5" >
            {isLoading ?
                <LoadingSpinner />
                : null}
            <motion.div layout className="row">
                <div className="col-md-12">
                    <AnimatePresence>
                        <motion.div
                            layout
                            key="form-card"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0, y: -30 }}   // ⬅️ efecto de salida de la tarjeta completa
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                        >
                            <div
                                className="card shadow-lg  p-5 border-0"
                                style={{ borderRadius: '20px' }}
                            >

                                <div className="row">
                                    <motion.h1 className="color-primary"
                                        initial={{ opacity: 0, y: -90 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                        Seguimiento de Abonos de Contrato
                                    </motion.h1>
                                    <hr className="mb-5" />
                                </div>

                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>



            </motion.div>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />


        </motion.div>
    )

}


export default SeguimientAbonosContrato